export class PlantRoleRequest {
    role: string;
    unitId: number;
    constructor(role: string, unitId: number) {
        this.role = role;
        this.unitId = unitId;
    }
}
